export enum LEAD_ROLES {
  'PROJECT_MANAGER',
  TEAM_LEAD = 'TEAM_LEAD',
  BUSINESS_ANALYST = 'BUSINESS_ANALYST',
  QA_MANAGER = 'QA_MANAGER',
}

export interface DateRange {
  start: string;
  end: string;
}

export interface TimelineDay {
  date: string;
  day: number;
  monthLabel: string;
}

export interface HeatmapBarSegment {
  id: string;
  startDate: string;
  endDate: string;
  color?: string;
  label?: string;
}

export interface HeatmapRowData {
  id: string;
  label: string;
  linkId?: string;
  bars?: HeatmapBarSegment[];
}

export interface HeatmapCriticalPeriodsBlock {
  bars: HeatmapBarSegment[];
}

export interface HeatmapLeavesBlock {
  rows: HeatmapRowData[];
  summaryBars: HeatmapBarSegment[];
}

export interface HeatmapSection {
  id: string;
  title: string;
  collapsible: boolean;
  summaryBars: HeatmapBarSegment[];
  rows?: HeatmapRowData[];
}

export interface HeatmapTimelineData {
  days: TimelineDay[];
  sections: HeatmapSection[];
}
